import { IncomingMessage } from 'http';

import { QueryFunction, QueryKey } from '@tanstack/react-query';

import fetchLastEntries from '../../../services/products/last-entries';
import { getLastEntriesKey } from '../query-keys';

const getLasEntries = (
  options: {
    locale: string;
    part: string;
    vehicle: string;
    detailed_prices: boolean;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof fetchLastEntries>>] => {
  return [
    getLastEntriesKey(options),
    ({
      queryKey: [, locale, part, vehicle, detailed_prices],
    }: {
      queryKey: string[];
    }) =>
      fetchLastEntries(
        {
          locale,
          ...(vehicle && { carIdentifier: vehicle }),
          detailed_prices: detailed_prices,
          ...(part && { partIdentifier: part }),
        },
        req
      ),
  ];
};

export default getLasEntries;
